import { Column, EditType } from '@src/model/table';
import { AddressGroup } from '@src/dtos/version.dto';
import React from 'react';
import { AddressesCell } from './addresses-cell';
import { AddressRuleCell } from '../addresses/address-rule-cell';
import { useStores } from '../../../store';
import { AddressInfoTooltip } from './address-info-tooltip';
import { isNotSaneAddress } from '@src/utils/versionUtils';
import {
    isValueDuplicate,
    MAX_NAME_LENGTH,
    maxLength,
    nameValidation,
    validateString
} from '@src/utils/validationUtils';
import { DisplayNameCell } from '../inventory-utils';
import { createDescriptionColumn } from '@src/components/shared/table/column-factories';

export const useAddressGroupsColumns = (): Column<AddressGroup>[] => {
    const { fwVersionStore } = useStores();
    return [
        {
            accessor: 'displayName',
            header: 'Name',
            width: '250px',
            displayOnEdit: true,
            disableEdit: (row: AddressGroup) => row.isDefault,
            type: EditType.Text,
            getPlaceholder: () => 'Enter name',
            isKeyField: true,
            mandatory: true,
            maxLength: MAX_NAME_LENGTH,
            validationRules: [isValueDuplicate, maxLength(MAX_NAME_LENGTH),
                (value) => nameValidation(value)],
            getDisplayElement: (column, row) => <DisplayNameCell displayName={row.displayName} />,
        },
        {
            accessor: 'addresses',
            header: 'Addresses',
            width: '350px',
            displayOnEdit: true,
            getValue: (row: AddressGroup) => row.addresses.filter(adr => isNotSaneAddress(adr)),
            type: EditType.CustomDropdown,
            selectProps: {mode: 'multiple', showSearch: true, showArrow: true, maxTagCount: 'responsive'},
            options: () => fwVersionStore.getAddresses.map(adr => ({label: adr.displayName, value: adr.id})),
            dropdownInfoContent: (id: string) => <AddressInfoTooltip header={fwVersionStore.getAddresses.find(a=>a.id === id)?.displayName || ''}
                                                                     subHeader={fwVersionStore.getAddresses.find(a=>a.id === id)?.value || ''}
                                                                     description={fwVersionStore.getAddresses.find(a=>a.id === id)?.description || ''} />,
            mandatory: false,
            getDisplayElement: (column, row) => <AddressesCell addressGroupData={row}/>
        },
        {
            accessor: 'id',
            header: 'Rules',
            width: '400px',
            displayOnEdit: false,
            type: EditType.Text,
            mandatory: false,
            getDisplayElement: (column, row) => <AddressRuleCell addressGroupData={row}/>
        },
        {
            ...createDescriptionColumn(450),
            type: EditType.Text,
            disableEdit: (row: AddressGroup) => row.isDefault,
            validationRules: [(value) => validateString(value, false, ['(', ')', '>'])]
        },
    ] as Column<AddressGroup>[];
};

